module.exports = __webpack_public_path__ + "img/OM.299d7167.svg";